import bgDesign from './bg-design.webp';
import broowingCoffeeImg from './broowing-coffee.webp';
import budgetMangrImg from './budget-manager.webp';
import displayPicImg from './dp.webp';
import displayPic2Img from './dp2.webp';
import displayPic3Img from './dp3.webp';
import displayPic4Img from './dp4.webp';
import engrNelvinLogoImg from './engr.nelvin-logo.webp';
import letsTalkImg from './lets-talk.webp';
import misoRoboticsImg from './miso-robotics.webp';
import mvLogoBlack from './mv-logo-black.webp';
import mvLogoOrig from './mv-logo-orig.webp';
import myBusiness from './my-business.webp';
import peryaGamesImg from './perya-game.webp';
import portfolioImg from './portfolio.webp';
import purinaImg from './purina.webp';
import revdojoImg from './revdojo.webp';
import rpsImg from './rps.webp';
import solaireImg from './solaire.webp';

export {
  bgDesign,
  broowingCoffeeImg,
  budgetMangrImg,
  displayPic4Img,
  displayPic3Img,
  displayPic2Img,
  displayPicImg,
  engrNelvinLogoImg,
  letsTalkImg,
  misoRoboticsImg,
  mvLogoBlack,
  mvLogoOrig,
  myBusiness,
  peryaGamesImg,
  portfolioImg,
  purinaImg,
  revdojoImg,
  rpsImg,
  solaireImg
};
